//
import { mapActions, mapState } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'
import { BarcodeScannerHandler } from '@/components/reusable_components'
import Translator from '@/services/translator'

//
import InventoryModel from '@/models/Warehouse/WhInventory'
import fields from './fields'

//
export default {
    name: 'inventory-update',
    components: {
        BarcodeScannerHandler,
        ModelForm,
    },
    computed: {
        //
        ...mapState('AuthModule', {
            user: 'user',
        }),

        /**
         *
         */
        dialogProps() {
            return {
                fields: fields.dialog,
            }
        },

        /**
         *
         */
        formProps() {
            return {
                loading: this.formBusy,
                fields: fields.take({
                    g_branch_office_id: this.user.hr_employee
                        .g_branch_office_id,
                }),
            }
        },
    },
    data() {
        return {
            dialogData: {},
            dialogDataIndex: null,
            dialogValue: false,
            editable: false,
            formBusy: false,
            formData: {
                flag_replace: true,
            },
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', ['setTitleTopBar']),

        //
        ...mapActions('SnackbarModalModule', [
            'setSnackbar',
            'setErrorSnackbar',
            'setSuccessSnackbar',
            'setWarningSnackbar',
        ]),

        /**
         *
         */
        codeScanned(val) {
            //
            const productIndex = this.formData.wh_selected_products.findIndex(
                this.findByUPCCode(val)
            )

            //
            console.log({
                productIndex,
                val,
            })

            //
            if (productIndex < 0) {
                //
                this.setErrorSnackbar('El producto no esta en la lista.')
            } else {
                //
                let product = this.formData.wh_selected_products[productIndex]

                //
                product['quantity'] = product.amount_found_new || 0

                //
                this.dialogData = {
                    upc_codes: product.upc_codes.join(', '),
                    internal_code: product.internal_code,
                    name: product.name,
                    quantity: product.amount_found_new || 0,
                }
                this.dialogDataIndex = productIndex
                this.dialogValue = true

                //
                setTimeout(this.select, 100)
            }
        },

        /**
         *
         */
        findByUPCCode: code => ({ upc_codes }) =>
            upc_codes.some(upc_code => code === upc_code),

        /**
         *
         */
        fetch() {
            this.formBusy = true
            return InventoryModel.modeler()
                .find(this.$route.params.id)
                .then(this.setFormData)
        },

        /**
         *
         */
        prevent(event) {
            if (event.which == '10' || event.which == '13') {
                event.preventDefault()
            } else if (event.which == '32') {
                this.submitDialog()
            }
        },

        /**
         *
         */
        select() {
            //
            const input = document
                .getElementsByName('quantity-dialog-input')
                .item(0)

            //
            input.addEventListener('keypress', this.prevent)
            input.select()
        },

        /**
         *
         */
        keyup(event) {
            switch (event.keyCode) {
                case 27:
                    this.dialogValue = false
                    break
            }
        },

        /**
         *
         */
        redirect() {
            this.$router.push({ name: 'inventory-list' })
        },

        /**
         *
         */
        reset() {
            //
            this.$refs.form
                .setWait(true)
                .then(this.fetch)
                .then(this.$refs.form.setWait)

            //
            window.addEventListener('keyup', this.keyup)
        },

        /**
         *
         */
        setFormData(model) {
            this.formBusy = false
            this.formData = model.reset()
        },

        /**
         *
         */
        error(error) {
            this.setSnackbar({
                type: 'error',
                title: 'Error.',
                message: Translator(InventoryModel, error.response.data),
                timeout: 3000,
            })
        },

        /**
         *
         */
        success() {
            this.setSnackbar({
                type: 'success',
                title: 'Éxito.',
                message: 'Inventario actualizado.',
                timeout: 3000,
            }).then(this.redirect)
        },

        /**
         *
         */
        submit() {
            this.$refs.form.setWait(true).then(this.update)
        },

        /**
         *
         */
        submitDialog() {
            this.formData.wh_selected_products[
                this.dialogDataIndex
            ].amount_found_new = this.dialogData.quantity
            this.dialogValue = false
            this.setSuccessSnackbar('Cantidad modificada.')
        },

        /**
         *
         */
        submitEdit(val) {
            this.editable = val
        },

        /**
         *
         */
        update(model) {
            model
                .take()
                .sync(model.toTake())
                .then(this.success)
                .catch(this.error)
                .then(this.$refs.form.setWait)
        },
    },
    watch: {
        'formData.flag_replace'() {
            this.formData.toggleDetailReplace()
        }
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('EXECUTE_TAKE_INVENTORY')) ctx.$router.push('/')
        })
    },
    beforeMount() {
        this.setTitleTopBar('Tomar inventario')
    },
    mounted() {
        this.reset()
    },
    destroyed() {
        window.removeEventListener('keyup', this.keyup)
    },
}
